import { Questionario, Resposta } from "unb-questionario-componente";

export class EstudoRenovacao {
  public id: number; 
  public periodo: number;
  public aluno: number;
  public data: Date;
  public renovado:  boolean;
  public houveAlteracaoSituacao: boolean;
  public descricaoAlteracao: string;
  public bolsaAlimentacao:  boolean;
  public moradia:  boolean;
  public transporte:  boolean;
  public auxilioSocioeconomico:  boolean;
  public creche:  boolean;
  public moradiaDeficiencia:  boolean;
  public codigoEstudoSocioenocomicoRenovado: number;

  // variaveis transient
  public alunoNome: string;
  public alunoRa: string;
  public alunoNivel: number;
  public usuarioResponsavel: string;
  public idNovoEstudo: number;
  public situacaoNovoEstudo: number;


}
